var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9997H4.07782V4.86898H6.85083V2.49214H6.85165L6.85083 1.98047H0V11.9997ZM4.07782 3.28433H5.54601V3.96115H4.07782V3.28433ZM1.30482 3.28433H2.77301V3.96115H1.30482V3.28433ZM1.30482 5.26515H2.77301V5.94197H1.30482V5.26515ZM1.30482 7.24583H2.77301V7.92265H1.30482V7.24583ZM1.30482 9.22664H2.77301V9.90346H1.30482V9.22664Z",
    fill: "#535151",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97656 0H4.86603V1.304H1.97656V0Z",
    fill: "#535151",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83093 3.16943H7.52734L7.52898 4.86959H8.83093V3.16943Z",
    fill: "#535151",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0048 5.54639H4.75781V12.0002H12.0048V5.54639ZM7.92698 9.90405H6.06263V9.22723H7.92698V9.90405ZM7.92698 7.92337H6.06263V7.24655H7.92698V7.92337ZM10.7 9.90405H8.83564V9.22723H10.7V9.90405ZM10.7 7.92337H8.83564V7.24655H10.7V7.92337Z",
    fill: "#535151",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.510cabd2a5c702a219d5125a6d4f8fe5.svg";
export { ForwardRef as ReactComponent };